import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState, type ReactNode } from "react";
import { useAuth } from "../lib/auth";
import { FullPageLoading } from "./Loading";
import { Eyebrow, HeadingItalic } from "./design";

export default function AdminProtectedRoute({
  children,
}: {
  children: ReactNode;
}) {
  const { user, loading, isAdmin, refreshClaims } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (user && !isAdmin) {
        // Possibly stale claims — force one refresh.
        try {
          await refreshClaims();
        } catch {
          /* noop */
        }
      }
      if (!cancelled) setChecking(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [user, isAdmin, refreshClaims]);

  if (loading || checking) return <FullPageLoading />;
  if (!user) {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    );
  }
  if (!isAdmin) {
    return (
      <div
        className="paper-bg"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 22,
        }}
      >
        <div
          style={{
            background: "var(--paper-50)",
            border: "1px solid rgba(43,26,15,0.10)",
            borderRadius: 14,
            padding: "28px 24px",
            maxWidth: 420,
            width: "100%",
            textAlign: "center",
            boxShadow:
              "0 1px 0 rgba(43,26,15,0.04), 0 14px 24px -8px rgba(43,26,15,0.14)",
          }}
        >
          <Eyebrow>Admin-Bereich</Eyebrow>
          <HeadingItalic size={28}>
            Kein <em>Zugriff</em>.
          </HeadingItalic>
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontSize: 15,
              color: "var(--ink-soft)",
              margin: "0 0 22px",
            }}
          >
            Dieses Konto ist nicht als Admin freigeschaltet.
          </p>
          <a
            href="/admin/login"
            className="btn-primary"
            style={{ display: "inline-flex" }}
          >
            Mit anderem Konto anmelden
          </a>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
